import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { RoleEnum } from '../models/enums/RoleEnum';
import { ActionTypeEnum } from '../models/enums/ActionTypeEnum';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private authService: AuthenticationService) { }

  // Check if the user has a specific role
  canAdd(): boolean {
    return true;
    /*
    return this.authService.hasRole(RoleEnum.SuperAdmin) ||
      this.authService.hasRole(RoleEnum.Admin) ||
      this.authService.hasRole(RoleEnum.Dealer) ||
      this.authService.hasRole(RoleEnum.Customer);
      */
  }

  canUpdate(): boolean {
    return true;
    /*
    return this.authService.hasRole(RoleEnum.SuperAdmin) ||
      this.authService.hasRole(RoleEnum.Admin) ||
      this.authService.hasRole(RoleEnum.Dealer) ||
      this.authService.hasRole(RoleEnum.Customer);
      */
  }

  canDelete(): boolean {
    return true;
    /*
    return this.authService.hasRole(RoleEnum.SuperAdmin) ||
      this.authService.hasRole(RoleEnum.Admin) ||
      this.authService.hasRole(RoleEnum.Dealer) ||
      this.authService.hasRole(RoleEnum.Customer);*/
  }

  hasAnyRole(rolesToCheck: ActionTypeEnum[]): boolean {
    const userRoles = this.authService.getUserRoles(); // e.g., ['Admin', 'Dealer']
    return rolesToCheck.some(role => userRoles.includes(role));
  }

  // Generic method to check access for any feature
  /*canAccessFeature(feature: string): boolean {
    const roles = this.authService.getUserRoles();
    switch (feature) {
      case ActionTypeEnum.Add:
        return roles.includes(RoleEnum.Admin) || roles.includes(RoleEnum.Dealer) || roles.includes(RoleEnum.Customer);
      case ActionTypeEnum.Update:
        return roles.includes(RoleEnum.Admin) || roles.includes(RoleEnum.Dealer) || roles.includes(RoleEnum.Customer);
      case ActionTypeEnum.Delete:
        return roles.includes(RoleEnum.Admin);
      default:
        return false;
    }
  }*/
}
